import React from "react"
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
} from "reactstrap"
import * as Icon from "react-feather";
import { auth, database } from "firebase";
import PerfectScrollbar from "react-perfect-scrollbar";
import moment from 'moment';
import styled from 'styled-components';
import { connect } from "react-redux";

const UserDropdown = props => {
  return (
    <DropdownMenu right>
      <DropdownItem
        tag="a"
        href="/login"
        onClick={e => {
          auth().signOut();
          window.location.reload();
        }}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    langDropdown: false,
    shoppingCart: [],
    suggestions: [],
    notifications: [],
  }

  componentDidMount() {
    if (this.props.roleFromClaims && this.props.roleFromClaims !== "donor") {
      database()
        .ref('/notification')
        .once('value')
        .then(snap => {
          const data = snap.val();
          const activeNotificaitons = Object.values(data)
            .reduce((acc, dateWise) => {
              return [...acc, ...Object.values(dateWise).filter(notif => notif.s === 1)] // s for status, 1 means active
            }, []);

          const compare = (a,b) => moment(b.expiryDate).valueOf() - moment(a.expiryDate).valueOf()
          activeNotificaitons.sort(compare);

          // console.log('notfications', activeNotificaitons);
          this.setState({ notifications: activeNotificaitons });
        })
        .catch(err => console.log('err fetching notifications', err));
    }
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }

  removeItem = id => {
    let cart = this.state.shoppingCart

    let updatedCart = cart.filter(i => i.id !== id)

    this.setState({
      shoppingCart: updatedCart
    })
  }

  removeNotif = (notif) => {
    const { id, createdAt } = notif;
    const expiryDate = moment(createdAt).add(2, 'days').format('YYYY-MM-DD');

    database()
      .ref(`/notification/${expiryDate}/${id}/s`).set(0)
      .then(() => {
        const filteredNotif = this.state.notifications.filter(n => n.id !== notif.id);
        this.setState({ notifications: [...filteredNotif] });
      })
  }

  handleLangDropdown = () =>
    this.setState({ langDropdown: !this.state.langDropdown })

  render() {
    return (
      <React.Fragment>
        <ul></ul>
        <ul className="nav navbar-nav navbar-nav-user float-right">
          {
            this.props.roleFromClaims && this.props.roleFromClaims === "admin" && <UncontrolledDropdown
              className="dropdown-notification nav-item"
              tag="li"
            >
              <DropdownToggle
                tag="a"
                data-toggle="dropdown"
                aria-expanded={this.state.dropdownNotification}
                className="nav-link nav-link-label"
                style={{ position: 'relative' }}
              >
                <Icon.Bell size={21} />
                {this.state.notifications.length ? <Dot /> : <></>}
              </DropdownToggle>
              <DropdownMenu
                tag="ul"
                right
                className="dropdown-menu-media"
              >
                <li className="dropdown-menu-header">
                  <div className="dropdown-header mt-0">
                    <h3 className="text-white">Notifications</h3>
                  </div>
                </li>
                <PerfectScrollbar
                  className="media-list overflow-hidden position-relative"
                  options={{
                    wheelPropagation: false
                  }}
                >
                  <div className="d-flex justify-content-between" style={{ flexDirection: 'column' }}>
                    {
                      this.state.notifications.length > 0 ? this.state.notifications.map(notif => (
                        <Media className="d-flex align-items-start" style={{ position: 'relative' }} key={notif.id}>
                          <Media body>
                            <Media
                              heading
                              className="primary media-heading"
                              tag="h6"
                            >
                              Items expiring on {moment(notif.createdAt).add(2, 'days').format('YYYY-MM-DD')}
                            </Media>
                            <small className="notification-text">
                              {notif.message}
                            </small>
                          </Media>
                          <Close onClick={() => this.removeNotif(notif)}>&#10005;</Close>
                        </Media>
                      )) : (
                          <span style={{ padding: '1rem' }}>Nothing here!</span>
                        )
                    }
                  </div>
                </PerfectScrollbar>
              </DropdownMenu>
            </UncontrolledDropdown>
          }
          <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
            <DropdownToggle tag="a" className="nav-link dropdown-user-link">
              <div className="user-nav d-sm-flex d-none">
                <span className="user-name text-bold-600">
                  {this.props.roleFromClaims && this.props.roleFromClaims === "admin" ? "Food Bank" : "Food Bank Supplier"}
                </span>
                <span className="user-status">Available</span>
              </div>
              <span data-tour="user">
                <img
                  src={this.props.userImg}
                  className="round"
                  height="40"
                  width="40"
                  alt="avatar"
                />
              </span>
            </DropdownToggle>
            <UserDropdown {...this.props} />
          </UncontrolledDropdown>
        </ul>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  roleFromClaims: state.auth.login.roleFromClaims
})

export default connect(
  mapState
)(NavbarUser);

const Close = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  font-size: 14px;
  color: #7367f0;

  &:hover {
    color: #000;
    font-size: 16px; 
  }
`;

const Dot = styled.span`
  position: absolute;
  width: 8px;
  height: 8px;
  background: #ff9f43;
  border-radius: 4px;
  right: 6px;
  top: 19px;
`;